import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { addCarYearQueryParams } from '../common/addcars';

export const AddCarYearBeforeOnboardingStep: Step = {
  id: 'addCarYear',
  pathname: '/addcaryear',
  queryParams: addCarYearQueryParams,
  excludeFromProgressCalculation: true,

  canShow: (appData) => {
    if (appData.addingNewCar) {
      return true;
    }

    if (appData.isFromMAL) {
      return false;
    }
    if (appData.isOnboardingLite) {
      return false;
    }
    // If insurance is selected, cars will be asked in the onboarding section.
    if (appData.selectedService?.insurance) {
      return false;
    }

    return !!(appData.selectedService?.garage || appData.selectedService?.dwep || appData.selectedService?.refi);
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    if (appData.signupParams?.needNNOInsurance) {
      return true;
    }
    if (appData.initialCarAddCarByVin) {
      return true;
    }
    return appData.addingNewCar ? !!appData.addingNewCar.car.year : !!appData.signupParams?.initialCar?.year;
  },
  category: () => StepCategory.Cars,
};
